<template>
  <dx-modal
    id="mxmed-professional-resources-modal"
    :value="show"
    :title="title"
    @input="close"
    :closable="false"
  >
    <div v-if="loading" class="loading loading-lg" style="padding: 2rem"></div>
    <template v-else>
      <div class="empty" v-if="mxmedItems.length === 0">
        <p class="empty-title h5">Nenhum item disponível</p>
        <p class="empty-subtitle">
          <template v-if="type === 'procedure'">
            Não há procedimentos cadastrados para este profissional no MxMed.
          </template>
          <template v-else>
            Não há convênios cadastrados no MxMed.
          </template>
        </p>
      </div>
      <table class="table" v-else>
        <thead>
          <tr>
            <th>MxMed</th>
            <th style="width: 1.5rem"></th>
            <th>Stenci</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in mxmedItems" :key="item.id">
            <td>{{ item.name }}</td>
            <td class="text-center">
              <fa-icon :icon="['fal', 'arrow-right']" class="text-gray" />
            </td>
            <td>
              <select class="form-select" v-model="item.stenciId">
                <option value="">[Selecione]</option>
                <option
                  v-for="opt in stenciItems"
                  :key="opt.id"
                  :value="opt.id"
                >{{ opt.name }}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <template v-slot:footer>
      <button class="btn btn-gray" @click="close">Cancelar</button>
      <button
        class="btn btn-primary ml-2"
        :class="{ loading: loading }"
        :disabled="loading || !isValid"
        @click="save"
      >Salvar</button>
    </template>
  </dx-modal>
</template>

<script>
import * as expenseApi from '@/app/expense/api';
import * as insuranceApi from '@/app/insurance/api';
import api from '../api';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    professionalId: {
      type: String,
      required: true,
    },
    mxmedProfessionalId: {
      type: String,
      required: true,
    },
    procedures: {
      type: Array,
      default: () => [],
    },
    insurances: {
      type: Array,
      default: () => [],
    },
    mxmedInsurances: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: true,
      mxmedItems: [],
      stenciItems: [],
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    title() {
      return this.type === 'procedure' ? 'Procedimentos' : 'Convênios';
    },
    isValid() {
      if (this.type === 'procedure') {
        return this.mxmedItems.some(item => item.stenciId);
      }
      return true;
    },
    currentMappings() {
      return this.type === 'procedure' ? this.procedures : this.insurances;
    },
  },
  methods: {
    async init() {
      this.loading = true;
      try {
        if (this.type === 'procedure') {
          await this.initProcedures();
        } else {
          await this.initInsurances();
        }
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async initProcedures() {
      const [proceduresData, expensesData] = await Promise.all([
        api.professional.findProcedures(this.mxmedProfessionalId),
        expenseApi.find({
          active: true,
          types: 'evaluation,consultation,exam,procedure,session',
          limit: 0,
        }),
      ]);

      this.stenciItems = expensesData.items;
      this.mxmedItems = proceduresData.items.map((proc) => {
        const found = this.procedures.find(p => String(p.mappingId) === String(proc.id));
        return {
          id: proc.id,
          name: proc.name,
          stenciId: found ? found.id : '',
        };
      });
    },
    async initInsurances() {
      const { items } = await insuranceApi.find({
        limit: 0,
        active: true,
        planActive: true,
      });
      this.stenciItems = items;
      this.mxmedItems = this.mxmedInsurances.map((ins) => {
        const found = this.insurances.find(i => String(i.mappingId) === String(ins.id));
        return {
          id: ins.id,
          name: ins.name,
          stenciId: found ? found.id : '',
        };
      });
    },
    close() {
      this.$emit('update:show', false);
    },
    save() {
      const mapped = this.mxmedItems
        .filter(item => item.stenciId)
        .map(item => ({
          id: item.stenciId,
          mappingId: String(item.id),
        }));

      this.$emit('save', { type: this.type, items: mapped });
    },
  },
};
</script>

<style lang="scss">
#mxmed-professional-resources-modal {
  .modal-body {
    min-height: 250px;
  }
}
</style>
